import { useCallback, useEffect, useState } from "react";
import { apolloClient } from "../../../apollo/graphql";
import { OFFICE_PARTNER_CONTEXT } from "../../../apollo/queries/setups";
import type { OfficePartnerContext } from "../types/officePartnerContext";

export type { OfficePartnerContext };

export function useOfficePartnerContext() {
  const [context, setContext] = useState<OfficePartnerContext | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await apolloClient.query<{
        officePartnerContext: OfficePartnerContext;
      }>({
        query: OFFICE_PARTNER_CONTEXT,
        fetchPolicy: "network-only",
      });
      if (response.data?.officePartnerContext) {
        setContext(response.data.officePartnerContext);
      }
    } catch (err: unknown) {
      const message =
        err instanceof Error ? err.message : "Failed to load office partners";
      setError(message);
      setContext(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { context, loading, error, refresh };
}
